import type { IconDefinition } from '../index.tsx';

export const iconSterlingSign: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconSterlingSign',
  icon: [
    16,
    16,
    [],
    '',
    'M13.7231 14.8571C13.7231 15.5 13.1874 16 12.5803 16H3.43741C2.97312 16 2.58027 15.75 2.40169 15.3571C2.18741 14.9643 2.25884 14.5 2.54455 14.1429C3.54455 12.9286 4.11598 11.3929 4.11598 9.85714V9.14286H3.43741C2.79455 9.14286 2.29455 8.64286 2.29455 8C2.29455 7.39286 2.79455 6.85714 3.43741 6.85714H4.11598V4.5C4.11598 2.03571 6.15169 0 8.65169 0C9.15169 0 9.61598 0.107143 10.0803 0.25L12.9017 1.17857C13.5088 1.35714 13.8303 2 13.6517 2.60714C13.4374 3.21429 12.7946 3.53571 12.2231 3.35714L9.36598 2.42857C9.15169 2.35714 8.90169 2.28571 8.65169 2.28571C7.40169 2.28571 6.40169 3.28571 6.40169 4.5V6.85714H10.2946C10.9017 6.85714 11.4374 7.39286 11.4374 8C11.4374 8.64286 10.9017 9.14286 10.2946 9.14286H6.40169V9.85714C6.40169 11.2143 6.08027 12.5357 5.50884 13.7143H12.5803C13.1874 13.7143 13.7231 14.25 13.7231 14.8571Z',
  ],
};
